import React, { useState } from 'react'
import moment from 'moment'
import Button from '../../_library/Button'
import ConfirmModal from '../../_library/ConfirmModal'
import DateTimePickerReactTz from '../../_library/DateTimePickerReactTz'
import { DISPLAY_FORMAT } from '../../constants/timeFormats'

const FORMAT = 'YYYY-MM-DD HH:mm'

const Schedule = ({ handleSchedule = () => {}, isDisabled = false, event = {} }) => {
  const defaultDate = moment().add(16, 'minutes').toString()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [scheduledDate, setScheduledDate] = useState(defaultDate)
  const [scheduledDateError, setScheduledDateError] = useState(null)

  const handleScheduleButtonClick = e => {
    e.preventDefault()
    setIsModalOpen(true)
  }

  const handleScheduleDateChange = date => {
    setScheduledDate(date)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
    setScheduledDate(defaultDate)
  }

  const handleModalConfirm = response => {
    switch (response) {
      case 'ok':
        if (moment(scheduledDate).isSameOrBefore(moment())) {
          setScheduledDateError('Schedule date must be future date/time')
          return
        }

        const formattedDate = moment(scheduledDate).tz(event.timezone).format(FORMAT)

        handleSchedule(formattedDate)
        handleModalClose()
        break
      case 'cancel':
        handleModalClose()
        break
      default:
        break
    }
  }

  return (
    <>
      <Button
        className="btn btn-success btn-lg btn-shadow schedule-btn"
        onClick={handleScheduleButtonClick}
        disabled={isDisabled}
      >
        <span>
          <i className="fa fa-calendar" aria-hidden="true" /> Schedule message
        </span>
      </Button>
      <ConfirmModal
        isOpen={isModalOpen}
        header="Schedule message"
        content={
          <div>
            <DateTimePickerReactTz
              id="scheduleDate"
              placeholder="D MMM YYYY H:M AM"
              value={scheduledDate}
              onChange={handleScheduleDateChange}
              hint={
                <span>
                  <span>
                    Email will be sent:{' '}
                    <b>
                      {moment(scheduledDate).tz(event.timezone).format(DISPLAY_FORMAT)} (
                      {event.timezone || ''})
                    </b>
                  </span>
                  <br />
                  <span>The timing is based on the event timezone +15 minutes.</span>
                </span>
              }
              minDate={moment().add(16, 'minutes').format(FORMAT)}
              error={scheduledDateError}
              touched={true}
              timezone={event.timezone}
            />
          </div>
        }
        actions={[
          {
            value: 'ok',
            label: 'Schedule',
            className: 'btn btn-success btn-shadow',
            disabled: !scheduledDate,
          },
          {
            value: 'cancel',
            label: 'Cancel',
            className: 'btn btn-cancel',
          },
        ]}
        classNames={{
          modal: 'modal-dialog modal-trans modal-medium',
          container: 'modal-dialog schedule-modal-dialog modal-medium',
        }}
        onAction={handleModalConfirm}
      />
    </>
  )
}

export default Schedule
